import { MobileShell, T } from '@/components/dashboard/DashboardShell';
import ChatAssistant from './ChatAssistant';

export default function OwletAIMobile() {
  return (
    <MobileShell title="Owlet AI" subtitle="Your university assistant">
      <div style={{
        height: 'calc(100vh - 290px - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))',
        minHeight: 380,
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: 16, overflow: 'hidden',
      }}>
        <ChatAssistant />
      </div>
    </MobileShell>
  );
}
